import React from 'react';
import SlideWrapper from './SlideWrapper';

const SolutionArchitecture = () => (
  <SlideWrapper title="Solution Architecture - High Level">
    <div className="flex justify-center items-center h-full">
      <img 
        src={`${process.env.PUBLIC_URL}/AIMS-HIgh-level-Architecture.png`}
        alt="AIMS High-level Architecture" 
        className="max-w-full max-h-full object-contain"
      />
    </div>
  </SlideWrapper>
);

export default SolutionArchitecture;